export const configuration = {
  storageTypes: {
    LocalStorage: "LocalStorage",
    SessionStorage: "SessionStorage",
    InMemory: "InMemory",
  },
  callType: {
    POST: "POST",
    PUT: "PUT",
    GET: "GET",
    DELETE: "DELETE",
    PATCH: "PATCH",
  },
  authUrls: {
    login: "auth/login",
    refreshSession: "auth/refresh-token",
    logout: "auth/logout",
    validateToken: "auth/validate-token",
    signUp: "/auth/signup",
    resetPassword: "/auth/reset-password",
  },
  partialUrls: {
    countries: {
      getCountries: "/reference/countries",
    },
    regions: {
      getRegions: "/reference/regions",
    },
    reference: {
      buildNumber: "/reference/build-number",
    },
    loginRegion: {
      getAuthRegion: "/auth/region",
    },
    userManagement: {
      userDetailsFromToken: "/user-management/me",
      getUsers: "/user-management/users",
      createUser: "/user-management/users",
      exportUsers: "/user-management/export",
      getRoles: "/user-management/roles",
      checkUserEmail: "/user-management/users/email-check",
      getUserById: "/user-management/users/{id}",
      updateUser: "/user-management/users/{id}",
      userInjectors: "/user-management/users/{userId}/injectors",
      removeInjectors: "/user-management/users/{user_id}/injectors/remove",
      assignInjectors: "/user-management/users/{user_id}/injectors/assign",
      transferInjectors: "/user-management/users/{user_id}/injectors/transfer",
      assignedProductLines:
        "/user-management/users/{userId}/product-lines/assigned",
      removeProductLine: "/user-management/users/{userId}/product-lines/remove",
      searchProductLines:
        "/user-management/users/{userId}/product-lines/search",
      getProductFilterOptions:
        "/user-management/users/{userId}/product-lines/filter-options",
      getInjectorsAssignedToUser:
        "/user-management/users/{user_id}/injectors/assigned",
      searchInjectors: "/user-management/users/{user_id}/injectors/search",
      getInjectorFilterOptions:
        "/user-management/users/{user_id}/injectors/filter-options",
      // Revist below
      filter: "search",
      injectors: "user-management/users",
      updateExpiryDate: "/user-management/injectors/contract-expiry",
      getDetailedUser: "/user-management/me",
      deleteUser: "/user-management/users/{userId}",
      getPermissions: "/user-management/permissions",
      getUserPermissions: "/user-management/users/{userId}/permissions",
      overrideUserPermissions: "/user-management/users/{userId}/permissions",
      getInactivityThreshold:
        "/user-management/users/self/inactivity-threshold",
      updateInactivityThreshold:
        "/user-management/users/self/inactivity-threshold",
      updatePasslinkMobileAccessEndDate:
        "/user-management/users/expiry/passlink-mobile-access",
      acceptTermsAndConditions: "/user-management/accept-terms-and-condition",
      getUserProfileView: "/user-management/profile-view",
    },
    customerDetails: {
      customersByTypeParent: "/customer-onboarding/customers/by-type/parent",
      parentByCountry:
        "/customer-onboarding/customers/search/parent-by-country",
      childrenByCountry: "/customer-onboarding/customers/search/children",
      childrenSelectionByCountry:
        "/customer-onboarding/customers/search/children/selection",
      childCustomer:
        "/customer-onboarding/customers/{parent_customer_id}/children",
      customerInjectors:
        "/customer-onboarding/customers/{customer_id}/injectors",
      injectorsByCustomerId: "/customer-onboarding/customers/injectors",
    },
    customerOnboarding: {
      customers: "/customer-onboarding/customers",
      auditLogs: "/customer-onboarding/audit-logs",
      updateCustomer: "/customer-onboarding/customers/{customerId}",
      injectorsByCustomerId:
        "/customer-onboarding/customers/{customerId}/injectors",
      searchParentByCountry:
        "/customer-onboarding/customers/search/parent-by-country",
    },
    injector: {
      createInjectors: "/injector/injectors",
      deleteInjectors: "/injector/injectors/delete",
      getInjectorById: "/injector/injectors/{injectorId}",
      updateInjectors: "/injector/injectors/{injectorId}",
    },
    productOnboarding: {
      products: "/product-onboarding/products",
      updateProduct: "/product-onboarding/products/{id}",
      getUniqueProductNames:
        "/product-onboarding/products/unique-values/product_name",
    },
    supportTicket: {
      createSupportTicket: "/support-tickets",
      fetchSupportTickets: "/support-tickets/search",
      fetchSupportTicket: "/support-tickets/{id}",
      addAttachments: "/support-tickets/{ticketNumber}/attachments",
      addComments: "/support-tickets/{ticketNumber}/comments",
      updateTicketStatus: "/support-tickets/{ticketNumber}/status",
      closeTicket: "/support-tickets/{ticketNumber}/close",
      downloadAttachment: "/support-tickets/attachments/{attachment_id}",
    },
    injectorData: {
      getInjectorData: "/eu_data/get-user-injector-data",
      downloadInjectorData: "/eu_data/download-injector-data",
      fetchAuditLogs: "/eu_data/get-injector-data_audit_log",
    },
    filter: {
      search: "/search/{pageName}",
      filterOptions: "/search/{pageName}/filter-options",
    },
    softwarePackage: {
      packages: "/software-package/",
      packageById: "/software-package/software/{id}",
      createPackage: "/software-package/",
      updatePackage: "/software-package/{id}",
      deletePackage: "/software-package/{id}",
      publishPackage: "/software-package/{id}/publish",
      downloadPackage: "/software-package/download-package",
      downloadDocument: "/software-package/download-document",
      firebaseFile: "/software-package/firebase-file",
      firebaseFileSignedUrl: "/software-package/firebase-file/signed-url",
    },
    auditLog: {
      fetchAuditLogs: "/event-logs-frontend/list",
      filterFilters: "/event-logs/event-logs/filters",
      exportAuditData: "/event-logs-frontend/export",
      createEventLog: "/event-logs",
    },
    home: {
      getStatistics: "/analytics/kpis/{sub_menu}",
    },
    helpDocument: {
      getHelpDocument: `/user-management/help?expiration_minutes={expirationMinutes}`,
    },
    notifications: {
      getNotifications: "/notifications",
      markNotificationAsRead: "/notifications/{notification_id}/read",
      markAllNotificationsAsRead: "/notifications/read/all",
      getUnreadCount: "/notifications/unread-count",
      clearNotifications: "/notifications/{notification_id}/clear",
    },
    thingWorx: {
      injectors: "/thingworx/injectors",
      filterOptions: "/thingworx/filter-options",
    },
    biomedconfig: {
      getContractTypes: "/contracts/types",
      createContractTypes: "/contracts/types",
      updateContractTypes: "/contracts/types/{id}",
    },
    rum: {
      ingest: "/event-logs-frontend/rum",
    },
    globanConfig: {
      getGlobanList: "/globan-config/list",
      createGlobanConfig: "/globan-config/create",
      updateGlobanConfig: "/globan-config/update/{id}",
      getProductLines: "/globan-config/productline",
      getGlobanConfigById:
        "/globan-config/globan_numbers/product_name_id/{product_name_id}/sub_assembly_id/{sub_assembly_id}",
    },
  },
};
